<template>
<div class="chapter">
<div class="inner_page">
<section class="level1 hidden" data-number="1" epub:type="dedication" id="dedication">
<h1 class="hidden" data-number="1" epub:type="dedication">Dedication</h1>
<p>for</p>
<p>FRANK, who flew a glider,</p>
<p class="no_top_space">FRANK, who tapped a key,</p>
<p class="no_top_space">FRANK, who jumped,</p>
<p>and all the others.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?b8074ec6